<template>
  <div class="_root-used">
    <el-table
      ref="unScopeUse"
      border
      height="50vh"
      :data="flowByUserPaged"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      @row-click="handleRow"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '600',
      }"
    >
      <el-table-column
        type="selection"
        width="55"
        :selectable="
                  (row, index) => (row.canBeAuthorized !== 1 ? false : true)
                "
      ></el-table-column>
      <el-table-column label="账号" prop="targetId" show-overflow-tooltip></el-table-column>
      <el-table-column label="名称" prop="userName" show-overflow-tooltip></el-table-column>
      <el-table-column prop="groupNames" label="部门" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            :class="{'option-sty':true,'dis-sty': scope.row.canBeAuthorized !== 1}"
            @click="
                      sonChangAuth(
                        {
                          auth: 0,
                          flowId: rowData.flowId,
                          corpUserIdSet: scope.row.corpUserId.toString(),
                        },
                        scope.row
                      )
                    "
          >取消授权</el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <el-empty description="暂无数据"></el-empty>
      </template>
    </el-table>
    <el-row class="pageation page-box">
      <el-col :span="22" class="page-row page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="userPaged.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="userPaged.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="userPaged.pageTotal"
        />
        <el-go
          :page-size="userPaged.pageSize"
          :total="userPaged.pageTotal"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
      <el-col :span="2" class="page-row">
        <el-button
          size="mini"
          type="primary"
          style="margin-top:2px"
          :disable="selectRows.length === 0"
          @click="bacthCancel"
        >取消授权</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ElGo from "@/components/go/Go";
// API
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
export default {
  components: { ElGo },
  props: { rowData: { type: Object, default: {} } },
  data () {
    // 这里存放数据
    return {
      flowByUserPaged: [],
      userPaged: { itemPage: 1, pageSize: 10, pageTotal: 0 },
      selectRows: [],
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 表格行点击数据 */
    handleRow (row, column, event) {
      this.$refs.unScopeUse.toggleRowSelection(row)
    },
    /** 查询使用范围数据 */
    getflowByUserPaged () {
      const data = {
        auth: 1,
        flowId: this.rowData.flowId,
        ...this.userPaged,
      }, _this = this;
      ApiCorpMethods.FlowController.findflowByUserPaged(data).then(res => {
        if (!res.success) return this.$message.error(res.description)
        _this.flowByUserPaged = res.data
        _this.userPaged.pageTotal = res.total;
        _this.userPaged.pageSize = res.pageSize;
        _this.userPaged.pageNum = res.pageNum;
        _this.userPaged.pages = res.pages;
        _this.selectRows = []
      })
    },
    /** 批量取消选择 */
    bacthCancel () {
      if (this.selectRows.length === 0) return this.$message.warning('请选择要移出的数据')
      const userIds = this.selectRows.map(item => item.corpUserId)
      const data = {
        auth: 0,
        flowId: this.rowData.flowId,
        corpUserIdSet: userIds.toString()
      }
      this.sonChangAuth(data)
    },
    sonChangAuth (data, row) {
      if (row && row.canBeAuthorized !== 1) return _this.$message.warning('暂无当前员工所在部门管理权限，如需使用请联系管理员修改权限范围')
      this.$emit('changAuth', data, this.rowData)
    },
    /** 表格select */
    handleSelectionChange (val) {
      this.selectRows = val
    },
    /** 分页（每页条数change） */
    handleSizeChange (val) {
      this.userPaged.itemPage = 1;
      this.userPaged.pageSize = val;
      this.getflowByUserPaged();
    },
    /** 页数change */
    handleCurrentChange (val) {
      this.userPaged.itemPage = val;
      this.getflowByUserPaged();
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
}
</script>

<style lang='less' scoped>
/* @import url(); 引入公共css类 */
._root-used {
  padding-bottom: 10px;
  .page-box {
    display: flex;
    justify-content: flex-end;
  }
  .dis-sty {
    color: #ccc;
    cursor: not-allowed;
  }
  .page-row {
    padding: 5px 0;
  }
  .warn-img {
    color: #f8b762;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/components/contractApproval/unScopeUse.vue